import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { REGION } from "store/ref";

const app = getApp();
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  // downloaded.
  const clientAutoDelete = httpsCallable(
    functions,
    "api-client-download-bailiff-auto-delete",
  ); // { id},

  const clientForceDelete = httpsCallable(
    functions,
    "api-client-download-bailiff-force-delete",
  ); // { id},

  const clientCancelDelete = httpsCallable(
    functions,
    "api-client-download-bailiff-cancel-delete",
  ); // { id},

  // upload.
  const clientUploadAudio = httpsCallable(
    functions,
    "api-upload-client-job-file",
  ); // {fileName, contentType};

  const clientUploadPaper = httpsCallable(
    functions,
    "api-upload-paper-kyc-file",
  ); // {fileName, contentType};

  // generate qr code.
  const clientOrderBailiffQRGenerate = httpsCallable(
    functions,
    "api-client-order-bailiff-qr-generate",
  ); // {id}

  // return.
  return {
    client: {
      clientOrderBailiffQRGenerate,
      // audio
      clientUploadAudio,
      // paper
      clientUploadPaper,
      //
      clientAutoDelete,
      clientForceDelete,
      clientCancelDelete,
      // debug
    },
  };
};
